<template>
  <v-dialog :value="mostrar" persistent max-width="640" scrollable>
    <v-card class="ct-card">
      <v-card-title class="ct-head">
        <v-icon left color="#00695C">mdi-file-document-check-outline</v-icon>
        <span class="ct-title">Contrato de uso</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="ct-body">
        <p class="ct-intro">
          Para continuar, leia e aceite o contrato de uso da plataforma Templus.
        </p>

        <!-- =====================================================
             TEXTO DO CONTRATO — genérico/provisório.
             Substituir pelo contrato oficial quando estiver disponível.
             ===================================================== -->
        <div class="ct-doc">
          <p><strong>Termo de Uso da Plataforma Templus</strong></p>
          <p>
            Ao aceitar este termo, você declara ter lido e concordado com as condições de
            uso da plataforma Templus, fornecida pela Intelite Tecnologia ("Intelite").
          </p>
          <p><strong>1. Objeto.</strong> O Templus é uma plataforma de gestão para igrejas
            (membros, células, escola bíblica, eventos, check-in e relatórios), disponibilizada
            no modelo de assinatura mensal.</p>
          <p><strong>2. Assinatura e pagamento.</strong> O acesso é mantido mediante o pagamento
            da mensalidade correspondente ao plano contratado, cobrada de forma recorrente via
            PIX. O não pagamento poderá suspender o acesso à plataforma.</p>
          <p><strong>3. Responsabilidades do contratante.</strong> Você é responsável pela
            veracidade dos dados cadastrados e pelo uso adequado da plataforma, mantendo a
            confidencialidade das credenciais de acesso.</p>
          <p><strong>4. Proteção de dados (LGPD).</strong> Os dados pessoais tratados na
            plataforma são utilizados exclusivamente para a prestação do serviço, conforme a
            Lei nº 13.709/2018 (LGPD).</p>
          <p><strong>5. Cancelamento.</strong> A assinatura pode ser cancelada a qualquer momento,
            cessando as cobranças seguintes; não há reembolso de valores já pagos no período vigente.</p>
          <p style="color:#97a3a0;font-size:.85rem">
            Texto provisório de caráter genérico. O contrato oficial poderá substituí-lo a
            qualquer momento. O aceite fica registrado com data/hora e versão.
          </p>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <div class="ct-actions">
        <v-checkbox
          v-model="aceite"
          color="#00695C"
          hide-details
          class="ct-check"
          label="Li e aceito o contrato de uso."
        ></v-checkbox>
        <v-btn
          block large depressed dark color="#00695C"
          class="ct-btn"
          :disabled="!aceite"
          :loading="enviando"
          @click="aceitar"
        >
          Aceitar e continuar
        </v-btn>
        <button class="ct-sair" @click="sair">Sair</button>
      </div>
    </v-card>

    <Snackbar ref="chamaSnackbar" />
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { baseApiUrl } from '@/global'
import Snackbar from './snackbar.vue'

export default {
  name: 'ContratoDialog',
  components: { Snackbar },
  data() {
    return { aceite: false, enviando: false }
  },
  computed: {
    ...mapState({
      logado: state => state.isMenuVisible,
      user: state => state.userObj,
    }),
    mostrar() {
      // Só exige aceite quando a conta tem o campo explicitamente como false
      // (contas novas criadas no fluxo de cadastro). Usuários antigos, cujo
      // registro não possui o campo (undefined), NÃO são bloqueados.
      return !!this.logado && this.user && this.user.id && this.user.contratoAceito === false
    },
  },
  methods: {
    async aceitar() {
      this.enviando = true
      try {
        const token = sessionStorage.getItem('accToken')
        await axios.post(baseApiUrl + 'Usuarios/aceitarContrato?access_token=' + token, {})
        // atualiza o usuário em sessão e na store
        const u = JSON.parse(sessionStorage.getItem('user') || '{}')
        u.contratoAceito = true
        u.contratoAceitoEm = new Date().toISOString()
        sessionStorage.setItem('user', JSON.stringify(u))
        this.$store.dispatch('SetUser')
      } catch (e) {
        if (this.$refs.chamaSnackbar) {
          this.$refs.chamaSnackbar.snack('#EF5350', 'Não foi possível registrar o aceite. Tente novamente.', 'ERRO')
        }
      } finally {
        this.enviando = false
      }
    },
    sair() {
      this.$store.dispatch('Sair')
      this.$router.push({ path: '/login' })
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,600&display=swap');

.ct-card { border-radius: 16px !important; }
.ct-head { padding: 18px 22px; }
.ct-title { font-family: 'Fraunces', Georgia, serif; font-weight: 600; font-size: 1.25rem; color: #16322E; }
.ct-body { max-height: 50vh; }
.ct-intro { color: #5b6b67; margin: 16px 0 14px; }
.ct-doc {
  background: #F4F7F6; border: 1px solid #e6efec; border-radius: 12px;
  padding: 18px; color: #2b3a36; font-size: .92rem; line-height: 1.6;
}
.ct-doc p { margin: 0 0 10px; }
.ct-actions { padding: 16px 22px 20px; }
.ct-check { margin-top: 0; padding-top: 0; }
.ct-btn { border-radius: 999px !important; text-transform: none !important; letter-spacing: 0 !important; margin-top: 8px; }
.ct-sair {
  display: block; margin: 14px auto 0; background: none; border: none; cursor: pointer;
  color: #97a3a0; font-size: .85rem; text-decoration: underline;
}
</style>
